import { Dialog } from "./dialog";

export class DialogInfo {
  state: string | null = null;
  dialogs: Dialog[] = [];
}